import {TranslatePipe} from '@ngx-translate/core';
import {Component, inject, Input, OnInit} from '@angular/core';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss'],
  imports: [
    TranslatePipe
  ]
})
export class VideoComponent implements OnInit {
  private readonly sanitizer = inject(DomSanitizer);

  public active = false;
  public safeURL!: SafeResourceUrl;
  @Input() imagePath = 'assets/img/square2.jpg';
  @Input() videoURL = 'https://www.youtube.com/embed/rqaVh4FDZDE?autoplay=1';

  ngOnInit(): void {
    this.safeURL = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoURL);
  }

  public popupAction(state: boolean) {
    this.active = state;
  }

}
